import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { creditActions, creditSelector } from 'store/modules/credit';

export const useCreditPoolOverview = () => {
  const dispatch = useDispatch();
  const credit = useSelector(creditSelector);

  useEffect(() => {
    dispatch(creditActions.getCreditPoolOverview());
  }, [dispatch]);

  return credit.creditPoolOverview;
};
